import { c as _c } from "react/compiler-runtime";
import { IconPaperPlane2Outline18 } from "nucleo-ui-outline-18";
import { Button } from "@/components/ui/button";
import { ZERO_ADDRESS, getAutoWidgetsForTrigger, resolveWidgetPayload } from "@/lib/workflow/widget";
import { useWorkflow } from "../_hooks/useWorkflow";
import { useModalStore } from "@b3dotfun/sdk/global-account/react";
import React, { useCallback, useState } from "react";
interface TriggerNodeWidgetsProps {
  triggerType: string | undefined;
  payload: Record<string, unknown> | undefined;
  propValues?: Record<string, unknown>;
  workflowId?: string;
  orgId?: string;
  paymentLinkUrl?: string | null;
  isLoadingTriggerInfo?: boolean;
}

/**
 * Renders widget buttons for trigger nodes based on their type.
 * Auto-generates appropriate action buttons (e.g., AnySpend transfers) for specific trigger types.
 */
function TriggerNodeWidgets(t0) {
  const $ = _c(32);
  const {
    triggerType,
    payload,
    propValues,
    workflowId,
    orgId,
    paymentLinkUrl,
    isLoadingTriggerInfo
  } = t0;
  const setModalOpen = useModalStore(_temp);
  const setModalContentType = useModalStore(_temp2);
  const {
    data: workflowDetail
  } = useWorkflow(workflowId ?? null);
  const isPublished = workflowDetail?.status === "active";
  const [copied, setCopied] = useState(false);
  let t1;
  if ($[0] !== paymentLinkUrl) {
    t1 = e => {
      e.stopPropagation();
      if (!paymentLinkUrl) {
        return;
      }
      navigator.clipboard.writeText(paymentLinkUrl).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      });
    };
    $[0] = paymentLinkUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleCopy = t1;
  let enablePaymentLink;
  let t2;
  let t3;
  let t4;
  if ($[2] !== isPublished || $[3] !== orgId || $[4] !== payload || $[5] !== propValues || $[6] !== setModalContentType || $[7] !== setModalOpen || $[8] !== triggerType || $[9] !== workflowId) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const widgets = getAutoWidgetsForTrigger(triggerType, payload, propValues, isPublished);
      enablePaymentLink = payload?.enablePaymentLink === true;
      if (widgets.length === 0 && !enablePaymentLink) {
        t4 = null;
        break bb0;
      }
      let t5;
      if ($[14] !== orgId || $[15] !== payload || $[16] !== setModalContentType || $[17] !== setModalOpen || $[18] !== workflowId) {
        t5 = (e_0, widget) => {
          e_0.stopPropagation();
          const resolvedPayload = resolveWidgetPayload(widget.payload, payload || {});
          if (widget.action === "anySpendWorkflowTrigger") {
            const {
              recipientAddress,
              tokenAddress,
              chainId,
              amount
            } = resolvedPayload;
            const actionLabel = typeof resolvedPayload.actionLabel === "string" ? resolvedPayload.actionLabel : widget.label;
            if (typeof recipientAddress === "string" && typeof chainId === "number" && workflowId && orgId) {
              setModalContentType({
                type: "anySpendWorkflowTrigger",
                recipientAddress,
                tokenAddress: typeof tokenAddress === "string" ? tokenAddress : ZERO_ADDRESS,
                chainId,
                amount: typeof amount === "string" ? amount : "",
                workflowId,
                orgId,
                actionLabel
              });
              setModalOpen(true);
            }
          } else {
            if (widget.action === "anySpendDeposit" || widget.action === "anyspend-transfer") {
              const {
                recipientAddress: recipientAddress_0,
                destinationTokenChainId
              } = resolvedPayload;
              if (typeof recipientAddress_0 === "string" && typeof destinationTokenChainId === "number") {
                const rawDestinationTokenAddress = typeof resolvedPayload.destinationTokenAddress === "string" ? resolvedPayload.destinationTokenAddress : "";
                const hasSpecificDestinationToken = rawDestinationTokenAddress !== "" && rawDestinationTokenAddress !== ZERO_ADDRESS;
                if (hasSpecificDestinationToken) {
                  const actionLabel_0 = typeof resolvedPayload.actionLabel === "string" ? resolvedPayload.actionLabel : widget.label;
                  setModalContentType({
                    type: "anySpendDeposit",
                    recipientAddress: recipientAddress_0,
                    destinationTokenAddress: rawDestinationTokenAddress,
                    destinationTokenChainId,
                    actionLabel: actionLabel_0,
                    allowDirectTransfer: true,
                    showFiatOption: false
                  });
                } else {
                  setModalContentType({
                    type: "anySpend",
                    recipientAddress: recipientAddress_0,
                    defaultActiveTab: "crypto",
                    showFiatOption: false
                  });
                }
                setModalOpen(true);
              } else {
                console.error("Invalid payload for AnySpend widget action", {
                  widget,
                  resolvedPayload
                });
              }
            } else {
              if (widget.action === "open-url" && resolvedPayload.url) {
                window.open(String(resolvedPayload.url), "_blank");
              }
            }
          }
        };
        $[14] = orgId;
        $[15] = payload;
        $[16] = setModalContentType;
        $[17] = setModalOpen;
        $[18] = workflowId;
        $[19] = t5;
      } else {
        t5 = $[19];
      }
      const handleWidgetClick = t5;
      t2 = widgets.length > 0 ? "border-ds-border-default space-y-2 border-t pt-3" : "space-y-2";
      let t6;
      if ($[20] !== handleWidgetClick) {
        t6 = (widget_0, index) => <Button key={index} variant="black" onClick={e_1 => handleWidgetClick(e_1, widget_0)} className="w-full"><span className="flex items-center gap-2 text-xs"><IconPaperPlane2Outline18 className="h-3 w-3" />{widget_0.label}</span></Button>;
        $[20] = handleWidgetClick;
        $[21] = t6;
      } else {
        t6 = $[21];
      }
      t3 = widgets.map(t6);
    }
    $[2] = isPublished;
    $[3] = orgId;
    $[4] = payload;
    $[5] = propValues;
    $[6] = setModalContentType;
    $[7] = setModalOpen;
    $[8] = triggerType;
    $[9] = workflowId;
    $[10] = enablePaymentLink;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    enablePaymentLink = $[10];
    t2 = $[11];
    t3 = $[12];
    t4 = $[13];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  let t5;
  if ($[22] !== copied || $[23] !== enablePaymentLink || $[24] !== handleCopy || $[25] !== isLoadingTriggerInfo || $[26] !== paymentLinkUrl) {
    t5 = enablePaymentLink && <div className="border-ds-border-default border-t pt-3"><p className="label-xs text-ds-text-muted mb-2">Payment Link</p>{paymentLinkUrl ? <div className="flex items-center gap-2"><a href={/^https?:\/\//i.test(paymentLinkUrl) ? paymentLinkUrl : "#"} target="_blank" rel="noopener noreferrer" className="mono-xs bg-ds-neutral-100 dark:bg-ds-neutral-800 flex-1 truncate rounded px-2 py-1 text-blue-600 hover:underline dark:text-blue-400" title={paymentLinkUrl} onClick={_temp3}>{paymentLinkUrl}</a><button aria-label="Copy payment link URL" className="label-xs bg-ds-neutral-200 hover:bg-ds-neutral-300 dark:bg-ds-neutral-700 flex-shrink-0 rounded px-2 py-1 dark:hover:bg-zinc-600" onClick={handleCopy}>{copied ? "Copied!" : "Copy"}</button></div> : isLoadingTriggerInfo ? <p className="body-sm text-ds-text-disabled dark:text-ds-text-muted">Loading...</p> : <p className="body-sm text-ds-text-disabled dark:text-ds-text-muted">Publish workflow to generate payment link</p>}</div>;
    $[22] = copied;
    $[23] = enablePaymentLink;
    $[24] = handleCopy;
    $[25] = isLoadingTriggerInfo;
    $[26] = paymentLinkUrl;
    $[27] = t5;
  } else {
    t5 = $[27];
  }
  let t6;
  if ($[28] !== t2 || $[29] !== t3 || $[30] !== t5) {
    t6 = <div className={t2}>{t3}{t5}</div>;
    $[28] = t2;
    $[29] = t3;
    $[30] = t5;
    $[31] = t6;
  } else {
    t6 = $[31];
  }
  return t6;
}
function _temp3(e_2) {
  return e_2.stopPropagation();
}
function _temp2(state_0) {
  return state_0.setB3ModalContentType;
}
function _temp(state) {
  return state.setB3ModalOpen;
}
export default React.memo(TriggerNodeWidgets);